import { css } from "@emotion/css";
import { ExternalLink } from "@octopusdeploy/design-system-components";
import { fontWeight, themeTokens } from "@octopusdeploy/design-system-tokens";
import { ExternalLinkSlugs } from "~/areas/infrastructure/components/ArgoCDInstances/ArgoCDConstants";
import ConfigurationViewHelpImageSvg from "~/areas/infrastructure/components/ArgoCDInstances/DialogViews/components/ConfigurationViewHelpImage.svg";
import InstallationViewHelpImageSvg from "~/areas/infrastructure/components/ArgoCDInstances/DialogViews/components/InstallationViewHelpImage.svg";
import ProjectSelectionViewHelpImageSvg from "~/areas/infrastructure/components/ArgoCDInstances/DialogViews/components/ProjectSelectionViewHelpImage.svg";
import type { HelpPanelImage } from "~/components/OnboardingDialog/HelpPanel";
const helpStyles = {
    content: css({ marginTop: 0, h2: { marginTop: 0, fontWeight: fontWeight["700"], color: themeTokens.color.dialog.helpPanel.text }, p: { color: themeTokens.color.dialog.helpPanel.text } }),
    orderedList: css({ color: themeTokens.color.dialog.helpPanel.text, paddingLeft: "1.25rem", margin: 0, listStyleType: "decimal" }),
};
const DocsLink = <ExternalLink href={ExternalLinkSlugs.ArgoGatewayInstallationDocs}>View installation docs</ExternalLink>;
export const ConfigurationViewHelpContent = (<span className={helpStyles.content}>
        <h2>Connect Octopus to your Argo CD GitOps workflows</h2>
        <p>Provide details about your Argo CD instance to get started.</p>
        <p>On the next screen, we'll generate a custom Helm command to install the Octopus gateway.</p>
        <p>{DocsLink}</p>
    </span>);
export const ConfigurationViewHelpImage: HelpPanelImage = {
    altText: "Octopus connects to your Argo CD GitOps workflows",
    src: ConfigurationViewHelpImageSvg,
};
export const InstallationViewHelpContent = (<span className={helpStyles.content}>
        <h2>Keeping Octopus & Argo CD in sync</h2>
        <p>The gateway is a secure bridge between Octopus Deploy and your Argo CD instance.</p>
        <p>It syncs application mappings without Octopus needing direct access to your cluster.</p>
        <p>After installation, your Argo CD instance will be automatically registered in Octopus.</p>
        <p>{DocsLink}</p>
    </span>);
export const InstallationViewHelpImage: HelpPanelImage = {
    altText: "The Octopus gateway connects Octopus Deploy to your Argo CD instance",
    src: InstallationViewHelpImageSvg,
};
const ProjectSelectionDocsLink = <ExternalLink href={ExternalLinkSlugs.ArgoCDDStepsDocs}>Read the docs</ExternalLink>;
export const ProjectSelectionViewHelpContent = (<span className={helpStyles.content}>
        <h2>How to deploy with Argo CD</h2>
        <ol className={helpStyles.orderedList}>
            <li>Create or select an Octopus project.</li>
            <li>Add an Argo CD step to your process.</li>
            <li>Add annotations to your Argo CD applications to map them to Octopus projects, environments and tenants.</li>
            <li>Provide Git credentials for sources.</li>
            <li>Configure the remaining step settings.</li>
            <li>Create a release and deploy.</li>
        </ol>
        <p>{ProjectSelectionDocsLink}</p>
    </span>);
export const ProjectSelectionViewHelpImage: HelpPanelImage = {
    altText: "Argo CD deployment step cards showing application manifests and image tags updates",
    src: ProjectSelectionViewHelpImageSvg,
};
